import { render, staticRenderFns } from "./TabAttachments.vue?vue&type=template&id=6b04f3fa&"
import script from "./TabAttachments.vue?vue&type=script&lang=js&"
export * from "./TabAttachments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports